module.exports = __webpack_public_path__ + "img/225.dc74d31a.jpg";